<template>
  <div class="row container-fluid">
    <div class="col-sm-3 col-md-4 col-lg-3 mb-2 mb-md-0">
      <div class="breadcrumb-wrapper">
        <div class="">
          <nav aria-label="breadcrumb my-project-breadcrumb-item">
            <ol class="breadcrumb my-project-breadcrumb-item px-0">
              <li class="breadcrumb-item">
                <a  href="/Account/MyProjects" style=" text-decoration: none;">
                  {{ $resourceString["account.SideBar.MyProjects.Title"] }}
                </a>
              </li>
              <li class="breadcrumb-item">
                <span class="project-name">
                  {{ projectDetails.boardDetails.title }}
                </span>
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <div class="col-sm-2 col-md-3 col-lg-2 mb-2 mt-3 edit-project" v-if="userRole">
      <span @click="editProject">
        <span v-html="editProjectIcon"></span>
        {{ $resourceString["myProject.Project.EditPage.Title"] }}
      </span>
    </div>
    <div class="col-sm-3 col-md-4 col-lg-4" style="text-align: end;" v-if="userRole">
      <button class="btn btn-outline-primary mb-2 mb-md-0 "
      v-if="(this.projectDetails.boardDetails.sections.some(section =>  section.title === 'default' && section.contentItems.length != 0) && (this.projectDetails.boardDetails && this.projectDetails.boardDetails.status != 1))"

      @click.prevent = "handleShareProject"
      >
        <span v-html="projectShareIcon"></span>
        {{ $resourceString["myProject.Project.ShareProject.Title"] }}
      </button>
    </div>
    <div class="col-sm-3 col-md-4 col-lg-3 header-add-button" v-if="userRole">
      <add-item-button :onClickHandler="onClickHandler" :buttonText="buttonText"></add-item-button>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import addItemButton from "./my-project-add-button.vue"
import { globalIcons } from "../../../constants/global";
export default {
  props: ["projectDetails","onClickHandler","projectId", "userRole"],
  components: {
    addItemButton
  },

  data(){
    return{
      buttonText:this.$resourceString["myProject.Project.EditPage.AddItem"],
      editProjectIcon: globalIcons.EditProjectIcon,
      projectShareIcon: globalIcons.ProjectShareIcon
    }
  },
  methods: {
    ...mapActions({getUserTrayIdApiDetails:"myTray/getUserTrayIdApiDetails"}),
    editProject(){
      this.$emit("editProject");
    },
    handleShareProject(){
      let data = {
            boardId: this.projectId,
          };
          this.getUserTrayIdApiDetails(data);
      this.showModal('share-project')
    },
    showModal(name) {
      this.$modal.show(name + "-modal");
    },
  }
};
</script>

